import { FC } from 'react';
import PinView from 'containers/treasury/components/PinView';

const PinViewPage: FC = () => {
  return (
    <div className="h-screen w-screen">
      <PinView />
    </div>
  );
};

export default PinViewPage;
